import { ReactComponent as PeterSvg } from 'imgs/svg-icons/characters/Peter.svg';
import { ReactComponent as MayaSvg } from 'imgs/svg-icons/characters/Maya.svg';
import { ReactComponent as JeffSvg } from 'imgs/svg-icons/characters/Jeff.svg';
import { ReactComponent as JorgeSvg } from 'imgs/svg-icons/characters/Jorge.svg';
import { ReactComponent as NathanSvg } from 'imgs/svg-icons/characters/Nathan.svg';
import { ReactComponent as AlfieSvg } from 'imgs/svg-icons/characters/Alfie.svg';
import { ReactComponent as JennySvg } from 'imgs/svg-icons/characters/Jenny.svg';
import { ReactComponent as KellySvg } from 'imgs/svg-icons/characters/Kelly.svg';
import { ReactComponent as SadeSvg } from 'imgs/svg-icons/characters/Sade.svg';
import { ReactComponent as FatimaSvg } from 'imgs/svg-icons/characters/Fatima.svg';
import { ReactComponent as AdrianaSvg } from 'imgs/svg-icons/characters/Adriana.svg';
import { ReactComponent as LouisSvg } from 'imgs/svg-icons/characters/Louis.svg';
import { ReactComponent as OwenSvg } from 'imgs/svg-icons/characters/Owen.svg';
import { ReactComponent as CarlSvg } from 'imgs/svg-icons/characters/Carl.svg';
import { ReactComponent as ChanceySvg } from 'imgs/svg-icons/characters/Chancey.svg';
import { ReactComponent as AqidahSvg } from 'imgs/svg-icons/characters/Aqidah.svg';
import { ReactComponent as HimariSvg } from 'imgs/svg-icons/characters/Himari.svg';
import { ReactComponent as AhmedSvg } from 'imgs/svg-icons/characters/Ahmed.svg';
import { ReactComponent as CharlotteSvg } from 'imgs/svg-icons/characters/Charlotte.svg';
import { ReactComponent as ChristianSvg } from 'imgs/svg-icons/characters/Christian.svg';
import { ReactComponent as EmmanuelSvg } from 'imgs/svg-icons/characters/Emmanuel.svg';
import { ReactComponent as HazelSvg } from 'imgs/svg-icons/characters/Hazel.svg';
import { ReactComponent as HelenSvg } from 'imgs/svg-icons/characters/Helen.svg';
import { ReactComponent as JackSvg } from 'imgs/svg-icons/characters/Jack.svg';
import { ReactComponent as JasonSvg } from 'imgs/svg-icons/characters/Jason.svg';
import { ReactComponent as JillSvg } from 'imgs/svg-icons/characters/Jill.svg';
import { ReactComponent as KasunSvg } from 'imgs/svg-icons/characters/Kasun.svg';
import { ReactComponent as MattSvg } from 'imgs/svg-icons/characters/Matt.svg';
import { ReactComponent as MiaSvg } from 'imgs/svg-icons/characters/Mia.svg';
import { ReactComponent as OliviaSvg } from 'imgs/svg-icons/characters/Olivia.svg';
import { ReactComponent as OusmaneSvg } from 'imgs/svg-icons/characters/Ousmane.svg';
import { ReactComponent as ReneeSvg } from 'imgs/svg-icons/characters/Renee.svg';
import { ReactComponent as RobertSvg } from 'imgs/svg-icons/characters/Robert.svg';
import { ReactComponent as RohanSvg } from 'imgs/svg-icons/characters/Rohan.svg';
import { ReactComponent as VickiSvg } from 'imgs/svg-icons/characters/Vicki.svg';
import { ReactComponent as WilmaSvg } from 'imgs/svg-icons/characters/Wilma.svg';
import { CharacterStyle } from 'js/config/consts';

export interface Character {
  id: string;
  name: string;
  visualStyle: CharacterStyle;
  SvgComponent: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const CHARACTERS: Character[] = [
  { id: 'adriana', name: 'Adriana', visualStyle: 'Flat', SvgComponent: AdrianaSvg },
  { id: 'ahmed', name: 'Ahmed', visualStyle: 'Illustrated', SvgComponent: AhmedSvg },
  { id: 'alfie', name: 'Alfie', visualStyle: 'Comic', SvgComponent: AlfieSvg },
  { id: 'aqidah', name: 'Aqidah', visualStyle: 'Expressive', SvgComponent: AqidahSvg },
  { id: 'carl', name: 'Carl', visualStyle: 'Expressive', SvgComponent: CarlSvg },
  { id: 'chancey', name: 'Chancey', visualStyle: 'Expressive', SvgComponent: ChanceySvg },
  { id: 'charlotte', name: 'Charlotte', visualStyle: 'Illustrated', SvgComponent: CharlotteSvg },
  { id: 'christian', name: 'Christian', visualStyle: 'Illustrated', SvgComponent: ChristianSvg },
  { id: 'emmanuel', name: 'Emmanuel', visualStyle: 'Illustrated', SvgComponent: EmmanuelSvg },
  { id: 'fatima', name: 'Fatima', visualStyle: 'Comic', SvgComponent: FatimaSvg },
  { id: 'hazel', name: 'Hazel', visualStyle: 'Simple', SvgComponent: HazelSvg },
  { id: 'helen', name: 'Helen', visualStyle: 'Line Art', SvgComponent: HelenSvg },
  { id: 'himari', name: 'Himari', visualStyle: 'Expressive', SvgComponent: HimariSvg },
  { id: 'jack', name: 'Jack', visualStyle: 'Conceptual', SvgComponent: JackSvg },
  { id: 'jason', name: 'Jason', visualStyle: 'Simple', SvgComponent: JasonSvg },
  { id: 'jenny', name: 'Jenny', visualStyle: 'Comic', SvgComponent: JennySvg },
  { id: 'jeff', name: 'Jeff', visualStyle: 'Comic', SvgComponent: JeffSvg },
  { id: 'jill', name: 'Jill', visualStyle: 'Conceptual', SvgComponent: JillSvg },
  { id: 'jorge', name: 'Jorge', visualStyle: 'Comic', SvgComponent: JorgeSvg },
  { id: 'kasun', name: 'Kasun', visualStyle: 'Line Art', SvgComponent: KasunSvg },
  { id: 'kelly', name: 'Kelly', visualStyle: 'Comic', SvgComponent: KellySvg },
  { id: 'louis', name: 'Louis', visualStyle: 'Flat', SvgComponent: LouisSvg },
  { id: 'maya', name: 'Maya', visualStyle: 'Comic', SvgComponent: MayaSvg },
  { id: 'matt', name: 'Matt', visualStyle: 'Line Art', SvgComponent: MattSvg },
  { id: 'mia', name: 'Mia', visualStyle: 'Illustrated', SvgComponent: MiaSvg },
  { id: 'nathan', name: 'Nathan', visualStyle: 'Comic', SvgComponent: NathanSvg },
  { id: 'olivia', name: 'Olivia', visualStyle: 'Illustrated', SvgComponent: OliviaSvg },
  { id: 'ousmane', name: 'Ousmane', visualStyle: 'Illustrated', SvgComponent: OusmaneSvg },
  { id: 'owen', name: 'Owen', visualStyle: 'Flat', SvgComponent: OwenSvg },
  { id: 'peter', name: 'Peter', visualStyle: 'Comic', SvgComponent: PeterSvg },
  { id: 'renee', name: 'Renee', visualStyle: 'Comic', SvgComponent: ReneeSvg },
  { id: 'robert', name: 'Robert', visualStyle: 'Comic', SvgComponent: RobertSvg },
  { id: 'rohan', name: 'Rohan', visualStyle: 'Simple', SvgComponent: RohanSvg },
  { id: 'sade', name: 'Sade', visualStyle: 'Comic', SvgComponent: SadeSvg },
  { id: 'vicki', name: 'Vicki', visualStyle: 'Comic', SvgComponent: VickiSvg },
  { id: 'wilma', name: 'Wilma', visualStyle: 'Simple', SvgComponent: WilmaSvg }
];
